import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {Spinner} from "../Spinner";
import {SaveBar} from "../elements/SaveBar";
import {LocalStorage} from "../../utils/LocalStorage";
import {FaIcon} from "../FaIcon";
import {Switch} from "../buttons/Swtich";
import {AddClientModal} from "../agency/AddClientModal";
import { withTranslation } from 'react-i18next';


// "Mis Clientes" como launcher + editor (pedido UX de Pablo, 2026-06-02).
// Una sola lista: tus clientes ASIGNADOS arriba (con "Ver detalle →" que entra a /client/:id/)
// y, para quien puede asignar, los DISPONIBLES debajo (tildá para asignarte). Reemplaza al
// viejo /clients/ (que confundía) sin perder el acceso al detalle del cliente.
class UserModuleMarketingInfoClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            savingChanges: false,
            userModuleMarketingInfo: null,
            loggedUserCanAssignClients: false,
            loggedUserCanCreateClients: false,
            clientSearch: '',
            showInactive: false,
            originalSelected: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClientsChange = this.handleClientsChange.bind(this);
        this.toggleClient = this.toggleClient.bind(this);
        this.handleClientAdded = this.handleClientAdded.bind(this);
    }

    // Cliente creado desde el botón "Agregar cliente" (AddClientModal): lo sumamos a la lista
    // (queda en "Disponibles", activo) sin refetch para no pisar asignaciones sin guardar.
    handleClientAdded(newId, newName) {
        const info = this.state.userModuleMarketingInfo;
        if (!info) return;
        const exists = (info.clients || []).some((c) => String(c.id) === String(newId));
        if (exists) return;
        this.setState({
            userModuleMarketingInfo: {
                ...info,
                clients: [...(info.clients || []), {id: newId, name: newName, is_active: true}]
            }
        });
    }

    userModuleMarketingDataURL() {
        return API_URL + 'user/' + this.props.userId + '/module/marketing';
    }

    setIsSaving(new_value){
        this.setState({
            ...this.state,
            'savingChanges': new_value
        });
    }

    editingLoggedUser() {
        return this.props.userId === LocalStorage.fetchUserId();
    }

    getUserModuleMarketingData() {
        this.setIsSaving(true);
        new APIClient(this.userModuleMarketingDataURL()).call('GET').then((response) => {
            this.setIsSaving(false);
            if (response.status === 'ERROR') {
                alert(response['error_message']);
            } else if (response.status === 'OK') {
                this.setState({
                    userModuleMarketingInfo: {
                        'clients': response.data.clients,
                        'selectedClients': response.data.selected_clients
                    },
                    originalSelected: this._normSelected(response.data.selected_clients),
                    loggedUserCanAssignClients: response.data.user_doing_operation_can_assign_clients,
                    loggedUserCanCreateClients: response.data.user_doing_operation_can_create_clients
                });
            }
        })
    }

    handleClientsChange(selectedClients) {
        this.setState({
            userModuleMarketingInfo: {
                ...this.state.userModuleMarketingInfo,
                selectedClients: selectedClients
            }
        });
    }

    toggleClient(clientId) {
        const info = this.state.userModuleMarketingInfo;
        if (!info) return;
        const selected = (info.selectedClients || []).map((id) => id.toString());
        const next = selected.includes(clientId)
            ? selected.filter((id) => id !== clientId)
            : [...selected, clientId];
        this.handleClientsChange(next);
    }

    componentDidMount() {
        this.getUserModuleMarketingData();
    }

    handleSubmit() {
        this.setState({savingChanges: true});
        new APIClient(this.userModuleMarketingDataURL()).call('POST', {
            'clients': this.state.userModuleMarketingInfo.selectedClients
        }).then((data) => {
            let errors = [];
            const extra = {};
            if (data.status === 'ERROR') {
                errors = JSON.parse(data.errors);
            } else if (data.status === 'OK') {
                // Marca el estado actual como "guardado" → desaparece la barra de cambios sin guardar.
                extra.originalSelected = this._normSelected(this.state.userModuleMarketingInfo.selectedClients);
                this.props.afterSuccessfulSubmit();
            }
            this.setState({
                ...extra,
                savingChanges: false,
                userModuleMarketingInfo: {
                    ...this.state.userModuleMarketingInfo,
                    errors: errors
                }
            });
        });
    }

    // Snapshot ordenado de la selección, para comparar y detectar cambios sin guardar.
    _normSelected(arr) {
        return [...(arr || []).map((x) => String(x))].sort().join(',');
    }

    hasUnsavedChanges() {
        const info = this.state.userModuleMarketingInfo;
        if (!info || this.state.originalSelected == null) return false;
        return this._normSelected(info.selectedClients) !== this.state.originalSelected;
    }

    // Devuelve {assigned, available, canAssign, totalAssigned} ya filtrados por búsqueda y ordenados.
    getGroupedClients() {
        const info = this.state.userModuleMarketingInfo;
        const canAssign = this.state.loggedUserCanAssignClients;
        const selectedIds = new Set((info.selectedClients || []).map((id) => id.toString()));
        const all = info.clients || [];

        const search = (this.state.clientSearch || '').trim().toLowerCase();
        const matches = (c) => !search || (c.name || '').toLowerCase().includes(search);
        const byName = (a, b) => (a.name || '').localeCompare(b.name || '');
        // Por default mostramos sólo activos; el toggle revela los inactivos.
        const showInactive = this.state.showInactive;
        const isVisibleActive = (c) => showInactive || !!c.is_active;
        const inScope = (c) => canAssign || selectedIds.has(c.id.toString());

        const assigned = all.filter((c) => selectedIds.has(c.id.toString()) && matches(c) && isVisibleActive(c)).sort(byName);
        // Sólo quien puede asignar ve los "disponibles"; el read-only ve sólo sus asignados.
        const available = canAssign
            ? all.filter((c) => !selectedIds.has(c.id.toString()) && matches(c) && isVisibleActive(c)).sort(byName)
            : [];

        // Cuántos inactivos quedan ocultos (para el label del toggle), respetando búsqueda y alcance.
        const hiddenInactive = showInactive
            ? 0
            : all.filter((c) => !c.is_active && matches(c) && inScope(c)).length;

        return {assigned, available, canAssign, totalAssigned: selectedIds.size, hiddenInactive};
    }

    renderClientRow(client, isAssigned, canAssign, index) {
        const {t} = this.props;
        const id = client.id.toString();
        return (
            <li
                key={id}
                className={`my-clients__row ${isAssigned ? '-assigned' : '-available'}`}
                style={{animationDelay: `${Math.min(index, 12) * 22}ms`}}
            >
                {canAssign && (
                    <button
                        type="button"
                        className={`my-clients__check ${isAssigned ? '-on' : ''}`}
                        onClick={() => this.toggleClient(id)}
                        aria-pressed={isAssigned}
                        title={isAssigned
                            ? t('user_marketing.unassign', 'Quitar de mi asignación')
                            : t('user_marketing.assign', 'Asignar')}
                    >
                        {isAssigned && <FaIcon iconName="check"/>}
                    </button>
                )}

                <span className="my-clients__name" title={client.name}>{client.name}</span>

                {isAssigned ? (
                    <Link className="my-clients__detail" to={`/client/${id}/`}>
                        <span>{t('user_marketing.view_detail', 'Ver detalle')}</span>
                        <FaIcon iconName="chevron-right"/>
                    </Link>
                ) : (
                    <button type="button" className="my-clients__assign" onClick={() => this.toggleClient(id)}>
                        <FaIcon iconName="plus"/>
                        <span>{t('user_marketing.assign', 'Asignar')}</span>
                    </button>
                )}
            </li>
        );
    }

    renderGroup(labelKey, labelDefault, clients, isAssignedGroup, canAssign) {
        if (!clients || clients.length === 0) return null;
        const {t} = this.props;
        return (
            <div className={`my-clients__group ${isAssignedGroup ? '-assigned-group' : ''}`}>
                <div className="my-clients__group-head">
                    <span className="my-clients__group-label">{t(labelKey, labelDefault)}</span>
                    <span className="my-clients__group-count">{clients.length}</span>
                </div>
                <ul className="my-clients__list">
                    {clients.map((client, i) =>
                        this.renderClientRow(client, isAssignedGroup, canAssign, i)
                    )}
                </ul>
            </div>
        );
    }

    renderClientsLauncher() {
        const {t} = this.props;
        const {assigned, available, canAssign, hiddenInactive} = this.getGroupedClients();
        const search = (this.state.clientSearch || '').trim();
        const nothing = assigned.length === 0 && available.length === 0;

        return (
            <div className="my-clients">
                <div className="my-clients__searchbar">
                    <div className="my-clients__search">
                        <FaIcon iconName="search" className="my-clients__search-icon"/>
                        <input
                            type="text"
                            value={this.state.clientSearch}
                            onChange={(e) => this.setState({clientSearch: e.target.value})}
                            placeholder={t('user_marketing.search_placeholder', 'Buscar cliente…')}
                        />
                        {search && (
                            <button
                                type="button"
                                className="my-clients__search-clear"
                                onClick={() => this.setState({clientSearch: ''})}
                                aria-label="Limpiar"
                            >
                                <FaIcon iconName="times"/>
                            </button>
                        )}
                    </div>
                    <label className="my-clients__inactive-toggle">
                        <Switch
                            name="showInactive"
                            checked={this.state.showInactive}
                            onChange={(e) => this.setState({showInactive: e.target.checked})}
                            style={{margin: 0}}
                        />
                        <span>
                            {t('user_marketing.show_inactive', 'Mostrar inactivos')}
                            {hiddenInactive > 0 ? ` (${hiddenInactive})` : ''}
                        </span>
                    </label>
                </div>

                {nothing ? (
                    <div className="my-clients__empty">
                        <FaIcon iconName={search ? 'search' : 'handshake'}/>
                        <p>{search
                            ? t('user_marketing.no_search_results', 'Sin resultados para tu búsqueda.')
                            : t('user_marketing.no_clients', 'No hay clientes para mostrar.')}</p>
                    </div>
                ) : (
                    <>
                        {this.renderGroup('user_marketing.assigned_group', 'Asignados a ti', assigned, true, canAssign)}
                        {this.renderGroup('user_marketing.available_group', 'Disponibles', available, false, canAssign)}
                    </>
                )}

                {canAssign && !nothing && (
                    <p className="my-clients__hint">
                        <FaIcon iconName="info-circle"/>
                        <span>{t('user_marketing.launcher_hint', 'Marca un cliente para asignártelo · "Ver detalle" para entrar a su tablero.')}</span>
                    </p>
                )}
            </div>
        );
    }

    renderHeader() {
        const {t} = this.props;
        const title = this.editingLoggedUser()
            ? t('user_marketing.my_clients_title', 'Mis clientes')
            : t('user_marketing.assigned_clients');

        // Patrón estándar de la plataforma: box-header (fondo $scale1) + box-title,
        // igual que los tabs hermanos (ej. "Mis alertas" en UserEmailAlerts).
        return (
            <header className="box-header">
                <h2 className="box-title">{title}</h2>
                {this.state.loggedUserCanCreateClients && (
                    <div className="box-header-actions">
                        <AddClientModal showButton={true} onClientAdded={this.handleClientAdded}/>
                    </div>
                )}
            </header>
        );
    }

    renderModuleMarketingInfo() {
        if (this.state.userModuleMarketingInfo !== null) {
            return (
                <div className="box">
                    {this.renderHeader()}
                    {this.renderClientsLauncher()}
                </div>
            )
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    render() {
        const canAssign = this.state.loggedUserCanAssignClients;
        const hasChanges = this.hasUnsavedChanges();
        return (
            <form className="section-body-item -wide">
                {this.renderModuleMarketingInfo()}
                {/* Barra sticky de cambios sin guardar: el botón Guardar quedaba fuera de pantalla
                    y el usuario podía creer que asignar/desasignar autoguardaba. */}
                {canAssign && hasChanges && (
                    <SaveBar
                        hasChanges={true}
                        isSaving={this.state.savingChanges}
                        onClick={this.handleSubmit}
                    />
                )}
            </form>
        )
    }
}

export const UserModuleMarketingInfo = withTranslation()(UserModuleMarketingInfoClass);
